import React from 'react';
import { BrowserRouter as Router, Routes, Route, Navigate } from 'react-router-dom';
import LoginForm from './components/LoginForm';
import MainPage from './components/MainPage';
import TransportList from './components/TransportList';
import ChangePassword from './components/ChangePassword';
import Transport from './components/Transport';
import TransportAccountList from './components/TransportAccountList';
import TransportAccount from './components/TransportAccount';
import TransportBillingList from './components/TransportBillingList';
import ManageUser from './components/Manageuser';
import ManageMaster from './components/Managemaster';
import CompanyProfile from './components/CompanyProfile';
import CustomerProfile from './components/CustomerProfile';
import TransportAccount_Expense from './components/TransportAccount_Expense';
import TransportAccountList_Expense from './components/TransportAccountList_Expense';
import TransportAccount_Bill from './components/TransportAccount_Bill';
import TransportAccountList_Bill from './components/TransportAccountList_Bill';
import TransportAccount_Receipt from './components/TransportAccount_Receipt';
import TransportAccountList_Receipt from './components/TransportAccountList_Receipt';
import ManageCustomer_List from './components/ManageCustomer_List';
import Print_Transport from './components/print/Transport';
import Print_Bill from './components/print/Bill';
import Print_BillList from './components/print/BillList';
import Print_ReceiptList from './components/print/ReceiptList';
import Print_Receipt from './components/print/Receipt';
import Print_Expense from './components/print/Expense';
import Print_ExpenseTawi50 from './components/print/ExpenseTawi50';
import Print_ExpenseReceipt from './components/print/ExpenseReceipt';
import Dashboard from './components/Dashboard';
import Managebillitem from './components/Managebillitem';

const App = () => {
  return (
    <Routes>
      <Route path="*" element={<Navigate to="/" replace />} />
      <Route path="/" element={<MainPage />} />
      <Route path="/login" element={<LoginForm />} />
      <Route path="/main" element={<MainPage />} />
      <Route path="/TransportList" element={<TransportList />} />
      <Route path="/Transport" element={<Transport />} />
      <Route path="/TransportAccountList" element={<TransportAccountList />} />
      <Route path="/TransportAccountList_Expense" element={<TransportAccountList_Expense />} />
      <Route path="/TransportAccountList_Bill" element={<TransportAccountList_Bill />} />
            <Route path="/TransportAccountList_Receipt" element={<TransportAccountList_Receipt />} />
      <Route path="/TransportBillingList" element={<TransportBillingList />} />
      <Route path="/change-password" element={<ChangePassword />} />
      <Route path="/TransportAccount/:name" element={<TransportAccount />} />
      <Route path="/ManageUser" element={<ManageUser />} />
      <Route path="/ManageMaster" element={<ManageMaster />} />
      <Route path="/Managebillitem" element={<Managebillitem />} />
      
      <Route path="/ManageCompanyProfile" element={<CompanyProfile />} />
     
      
      <Route path="/TransportAccount_Expense" element={<TransportAccount_Expense />} />
      <Route path="/TransportAccount_Expense/:name" element={<TransportAccount_Expense />} />
      <Route path="/TransportAccount_Bill" element={<TransportAccount_Bill />} />
      <Route path="/TransportAccount_Bill/:name" element={<TransportAccount_Bill />} />

      <Route path="/TransportAccount_Receipt" element={<TransportAccount_Receipt />} />
      <Route path="/TransportAccount_Receipt/:name" element={<TransportAccount_Receipt />} />

      <Route path="/Dashboard" element={<Dashboard />} />
      <Route path="/ManageCustomerList" element={<ManageCustomer_List />} />
      <Route path="/ManageCustomerProfile" element={<CustomerProfile />} />
      <Route path="/ManageCustomerProfile/:name" element={<CustomerProfile />} />

      <Route path="/Print/Transport/:name" element={<Print_Transport />} />
      <Route path="/Print/Transport/:name/:id" element={<Print_Transport />} />
      <Route path="/Print/Bill/:name" element={<Print_Bill />} />
      <Route path="/Print/Receipt/:name" element={<Print_Receipt />} />
      <Route path="/Print/Bill/:name" element={<Print_Bill />} />
      
      <Route path="/Print/BillList/:name" element={<Print_BillList />} />
      <Route path="/Print/ReceiptList/:name" element={<Print_ReceiptList />} />

      <Route path="/Print/Expense/:name" element={<Print_Expense />} />
      <Route path="/Print/ExpenseTawi50/:name" element={<Print_ExpenseTawi50 />} />
      <Route path="/Print/ExpenseReceipt/:name" element={<Print_ExpenseReceipt />} />
      
   
    </Routes>
  );
};

export default App;
